import React, { Fragment } from 'react'
import { object } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import styled from 'styled-components'
import CartaoCredito from '../../../components/CartaoCredito/CartaoCredito'
import EscolhaParcelas from '../../../components/EscolhaParcelas/EscolhaParcelas'
import CVVInput from '../../../components/CVVInput/CVVInput'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { METODO_PAGAMENTO_CARTAO, PLANO_ANUAL, PLANO_TRIMESTRAL } from '../../../constants'
import { ETAPA_PAGAMENTO, ETAPA_PLANO } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'

const TituloFormaPagamento = styled.div`
  align-items: center;
  display: flex;

  small {
    margin-left: 5px;
    ${StyleGuide.tipografia.textoPequeno}
  }
`

const PagamentoCartaoCreditoConclusao = ( { etapaAtual } ) => {
  const { dadosEtapas, setarDadosEtapas } = useFluxosPagamento()
  const isPlanoAnual = !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_ANUAL.visualizacao
  const isPlanoTrimestral = !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_TRIMESTRAL.visualizacao
  const hasParcelaEscolhida = !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) && Object.prototype.hasOwnProperty.call( dadosEtapas[ ETAPA_PAGAMENTO ], 'parcela' )

  const salvarParcela = parcela => {
    const dadosPagamento = !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) && { ...dadosEtapas[ ETAPA_PAGAMENTO ], parcela }
    setarDadosEtapas( dadosPagamento, ETAPA_PAGAMENTO )
  }

  const salvarCVV = cvv => {
    if ( !isEmptyObject( cvv ) && cvv.valido ) {
      const dadosConclusao = { 'confirmacaoCVV': cvv.numeroCVV, 'isConclusaoPreenchida': true }
      setarDadosEtapas( dadosConclusao, etapaAtual.identificador )
    } else {
      setarDadosEtapas( {}, etapaAtual.identificador )
    }
  }

  return (
    <Fragment>
      <TituloFormaPagamento>
        <p className="info">{ METODO_PAGAMENTO_CARTAO.visualizacao }</p>
      </TituloFormaPagamento>

      <CartaoCredito
        cartao={ !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) && dadosEtapas[ ETAPA_PAGAMENTO ] }
        maxWidth="300px"
        resumido
      />

      <CVVInput
        handleCVV={ cvv => salvarCVV( cvv ) }
      />

      { ( isPlanoAnual || isPlanoTrimestral ) ?
        <EscolhaParcelas
          onConfirmar={ ( parcelaSelecionada ) => salvarParcela( parcelaSelecionada ) }
          parcelaEscolhidaExterna={ hasParcelaEscolhida ? dadosEtapas[ ETAPA_PAGAMENTO ].parcela : 1 }
          plano={ dadosEtapas[ ETAPA_PLANO ].tipo }
        /> : null}
    </Fragment>
  )
}

PagamentoCartaoCreditoConclusao.propTypes = {
  'etapaAtual': object.isRequired
}

export default PagamentoCartaoCreditoConclusao
